export default defineNuxtPlugin(nuxtApp => {
	const { startPageLoading, stopPageLoading, forceStopPageLoading } = usePageLoading();
	let readyForLoading = false;

	// 首屏 hydration 完成后再启用，避免刷新时闪 loading
	nuxtApp.hook("app:mounted", () => {
		readyForLoading = true;
	});

	nuxtApp.hook("page:start", () => {
		if (!readyForLoading) return;
		startPageLoading();
	});

	nuxtApp.hook("page:finish", () => {
		if (!readyForLoading) return;
		forceStopPageLoading();
	});

	nuxtApp.hook("vue:error", () => {
		forceStopPageLoading();
	});

	const router = useRouter();
	router.onError(() => {
		forceStopPageLoading();
	});
});
